// import React, { useState } from 'react';
// import './SelectBox.css';

// const SelectBoxLarge = ({ label, options, defaultValue, onChange }) => {
//   const [value, setValue] = useState(defaultValue);

//   const handleChange = (event) => {
//     setValue(event.target.value);
//     if (onChange) onChange(event);
//   };

//   return (
//     <div className='large-select-box-container'>
//       <select className='select-box common-text ftw-4' value={value} onChange={handleChange} >
//         <option value="" disabled hidden className='hidden-select-option fts-6'>  </option>
//         {options.map((option, index) => (
//           <option className='common-text ftw-4' key={index} value={option.value}>{option.label}</option>
//         ))}
//       </select>
//       <label className={`select-label  common-text ftw-4 ${value ? 'has-value' : ''}`}>{label}</label>
//       <div className="select-box-icon">
//         <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242"/>
//         </svg>
//       </div>
//     </div>
//   );
// };

// export default SelectBoxLarge;

import React, { useEffect, useState } from "react";
import "./SelectBox.css";
import { useTranslation } from "react-i18next";

const SelectBoxLarge = ({
  label,
  options = [],
  defaultValue,
  onChange,
  validators = [],
  isRequired = false,
  className = " ",
  error,
  border = "",
  important = false,
}) => {
  const [value, setValue] = useState(defaultValue || "");
  const [errors, setErrors] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  // Ensure validators is always an array
  const validatorArray = Array.isArray(validators)
    ? validators
    : validators
      ? [validators]
      : [];

  // Add isRequired validator if required prop is true
  const effectiveValidators = isRequired
    ? [
        ...(typeof validatorArray === "function"
          ? [validatorArray]
          : validatorArray),
        (val) =>
          (val !== null && val !== undefined && val !== "") ||
          "This field is required",
      ]
    : validatorArray;

  const validateInput = (inputValue) => {
    // Run all validators
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === "function") {
          const result = validator(inputValue);
          // Return error message if validation fails
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === "string");

    return newErrors;
  };

  const handleChange = (event) => {
    const newValue = event.target.value;

    // Validate input
    const newErrors = validateInput(newValue);

    // Update state
    setValue(newValue);
    setErrors(newErrors);

    // Call onChange regardless of validation
    if (onChange) onChange(event);
  };

  // Combine local errors with external error prop
  const displayErrors = error ? [error] : errors;

  return (
    <div className={`large-select-box-container posrel ${className}`}>
      <select
        className={`select-box common-text ftw-4 pointer-show ${displayErrors.length > 0 ? "input-error" : ""} ${border}`}
        value={value}
        onChange={handleChange}
      >
        <option value="" disabled hidden>
          {" "}
        </option>
        {options.map((option, index) => (
          <option
            className={`common-text ftw-4 `}
            key={index}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      <label
        className={`select-label common-text ftw-4 ${value ? "has-value" : ""}`}
      >
        {t(label)}
        {important && <span className="required-asterisk">*</span>}
      </label>
      <div className="select-box-icon">
        <svg
          width="8"
          height="6"
          viewBox="0 0 8 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242" />
        </svg>
      </div>
      {/* {displayErrors.length > 0 && (
        <div className="input-error-message  red posabs">
          {displayErrors[0]}
        </div>
      )} */}
    </div>
  );
};

export default SelectBoxLarge;
